<template>
  <el-dialog
    v-if="dialogVisible"
    class="transcation-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="dataForm"
      :model="dataForm"
      :label-position="position"
      :rules="editRule"
      :label-width="`${adaptationVars.formLabelWidth}px`"
    >
      <el-form-item label="选择节点" prop="nodeId">
        <el-select v-model="dataForm.nodeId" placeholder="请选择">
          <el-option
            v-for="item in nodeList"
            :key="item.userNodeId"
            :label="item.NodeName"
            :value="item.userNodeId"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="数量" prop="amount">
        <el-input v-model="dataForm.amount"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" :disabled="disabled" @click="handleCreateOffChain()"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'TransactionDialog',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  data() {
    return {
      disabled: false,
      dialogVisible: false,
      nodeList: [], //节点列表
      title: '交易',
      position: 'right',
      dataForm: {
        amount: '', //通道名称
        offChainId: '',
        nodeId: '',
        chanName: ''
      },
      editRule: {
        amount: [
          { required: true, message: '请输入', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {},
  methods: {
    //创建扩容节点
    handleCreateOffChain() {
      this.$refs.dataForm.validate(async valid => {
        if (valid) {
          this.disabled = true
          //获取form数据
          this.dataForm.chainId = this.$route.query.chainId
          this.dataForm.offChainId = JSON.parse(this.$route.query.detail).id
          this.dataForm.amount = Number(this.dataForm.amount)
          this.$apis.chain
            .channelTrade(this.dataForm)
            .then(res => {
              if (res) {
                this.$message.success('交易成功')
                this.$emit('updateChan:list')
                this.handleCancel()
              }
            })
            .catch(err => {
              this.disabled = false
            })
        } else {
          this.$message.warning('请完善信息')
          this.disabled = false
          return
        }
      })
    },
    //获取节点列表
    handleGetNodeList() {
      let param = {
        offChainId: JSON.parse(this.$route.query.detail).id,
        chainId: this.$route.query.chainId,
        chanName: this.dataForm.chanName
      }
      this.$apis.chain.getTradeNodeList(param).then(res => {
        if (res) {
          this.nodeList = res.data
        }
      })
    },

    handleCancel() {
      this.dialogVisible = false
      this.disabled = false
      this.$refs.dataForm.resetFields()
    },
    handleOpen(data) {
      this.dataForm = {
        amount: '', //通道名称
        offChainId: '',
        nodeId: '',
        chanName: ''
      }
      this.dataForm.chanName = data.chanName
      this.dialogVisible = true
      this.handleGetNodeList()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme('transcation-dialog', (), ());
.transcation-dialog.common-dialog {
  @include adaptation(());
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }

  .el-select {
    width: 100%;
  }
}
</style>
